import React from "react";
import { useNavigate } from "react-router-dom";
import StampsTemplate from "./components/StampTemplate";
import { FaStar } from "react-icons/fa";

export default function LoyaltyCard({ card, index }) {
  const navigate = useNavigate();

  const offset = index * 60;

  const handleClick = () => {
    navigate(`/loyaltywallet/${card.id}`);
  };

  const getBonusIndexes = (stampsselected) => {
    if (stampsselected <= 5) return [stampsselected - 1];

    const numBonuses = stampsselected <= 10 ? 2 : stampsselected <= 15 ? 3 : 4;

    return Array.from(
      { length: numBonuses },
      (_, i) => Math.round(((i + 1) / numBonuses) * stampsselected) - 1
    );
  };

  const bonusIndexes = getBonusIndexes(card.stampsselected);
  const upcomingBonusIndex = bonusIndexes.find(
    (idx) => card.stampCount === idx
  );

  return (
    <div
      onClick={handleClick}
      className={`
        cursor-pointer
        transition-all duration-300
        ${card.color}
        rounded-xl
        shadow-lg ring-2 ring-black/10
        lg:static lg:top-auto lg:z-auto
        absolute left-0 right-0
      `}
      style={{
        top: `${offset}px`,
        zIndex: index + 1,
        marginBottom: "12px", // adds space for shadow between cards
      }}
    >
      <div className="p-4 h-[250px] flex flex-col justify-between relative overflow-hidden rounded-xl">
        {/* Header */}
        <div className="flex justify-between items-center">
          {/* Left: Logo & Brand */}
          <div className="flex items-center gap-2">
            <div className="text-white text-2xl">{card.logo}</div>
            <h2 className="text-lg font-semibold text-white whitespace-nowrap">
              {card.brand}
            </h2>
          </div>

          {/* Right: Stamps Info + Bonus Badge */}
          <div className="flex items-center gap-1">
            <div className="flex items-center gap-2 text-white text-sm">
              <span>
                {card.stampCount}/{card.stampsselected}
              </span>
              {upcomingBonusIndex === undefined && (
                <span className="uppercase">{card.type}</span>
              )}{" "}
            </div>

            {/* Bonus badge only if one away */}
            {upcomingBonusIndex !== undefined && (
              <div className="bg-redlight text-text text-xs px-2 py-1 rounded-full flex items-center gap-1 shadow-md animate-pulse">
                <FaStar size={12} />
                Bonus {bonusIndexes.indexOf(upcomingBonusIndex) + 1}!
              </div>
            )}
          </div>
        </div>

        {/* Stamps */}
        <div className="p-3 flex justify-start items-start">
          <StampsTemplate
            stampsselected={card.stampsselected}
            stampCount={card.stampCount}
            pickImg={"/static/media/coffee.0072c842.PNG"}
            pickunImg={"/static/media/coffee.0072c842.PNG"}
            stampedBackground={"#FFF"}
            unstampedBackground={"#FFF"}
            bonusList={card.bonuses}
          />
        </div>

        {/* Footer */}
        <div className="flex justify-between items-center text-white">
          <div className="text-sm tracking-widest">.... {card.last4}</div>
          <div>{card.icon}</div>
        </div>
      </div>
    </div>
  );
}
